var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crm-export"},[(_vm.title==='导出客户')?[(_vm.$authUtis.hasButtonAuth('aicc-crm', '/crm/client_mgr#export'))?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.title))]):_vm._e()]:_c('div',[_c('a',{on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.title))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }